import type { UploadResponse } from './file-handler';

export class Upload {
  public readonly key: string;
  public readonly originalName: string;
  public readonly url: string;

  constructor(uploadResponse: UploadResponse) {
    this.key = uploadResponse.key;
    this.originalName = uploadResponse.originalName;
    this.url = uploadResponse.url;
  }

  download() {
    downloadFileFromUrl(this.url);
  }
}

export function downloadFileFromUrl(url: string) {
  const anchorElement: HTMLAnchorElement = document.createElement('a');
  anchorElement.href = url;
  anchorElement.target = '_blank';
  anchorElement.download = ''; // Let the server/browser decide the filename if not specified
  document.body.appendChild(anchorElement);
  anchorElement.click();
  document.body.removeChild(anchorElement);
}
